document.addEventListener('DOMContentLoaded', function () {
   // Comment Section Title Change
   let titleElement = document.querySelector('h2.jdgm-rev-widg__title');
   if (titleElement) {
      titleElement.insertAdjacentHTML('beforebegin', "<h2 class='fraunces-font sec__content-heading heading-letter-spacing heading_weight'>Why People <em>Love</em> Us</h2>");
   }

   const videos = document.querySelectorAll('.inner-glow-videos shopable-video video');
   videos?.forEach((video) => {
      video.addEventListener('click', function () {
         // Eğer video zaten oynuyorsa, durdur ve 'play' sınıfını kaldır
         if (!video.paused) {
            video.pause();
            video.closest('shopable-video').classList.remove('play');
            return; // Burada işlemi sonlandırarak tekrar başlatmayı engelliyoruz
         }

         // Tüm videoları durdur ve 'play' sınıfını kaldır
         videos.forEach((v) => {
            v.pause();
            v.closest('shopable-video').classList.remove('play');
         });

         // Seçilen videoyu başlat ve 'play' sınıfını ekle
         video.play();
         video.closest('shopable-video').classList.add('play');
      });
   });
});
